import { LANGS, type Lang } from '../site/routes';
import { contentEn } from './content-en';
import { contentKo } from './content-ko';
import type { ContentPack, UiMessages } from './types';
import { uiEn } from './ui-en';
import { uiKo } from './ui-ko';

const UI: Record<Lang, UiMessages> = { ko: uiKo, en: uiEn };
const CONTENT: Record<Lang, ContentPack> = { ko: contentKo, en: contentEn };

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (LANGS as readonly string[]).includes(value);
}

export function ui(lang: Lang): UiMessages {
  return UI[lang];
}

export function content(lang: Lang): ContentPack {
  return CONTENT[lang];
}

export type { ContentPack, UiMessages, PageContent, FaqEntry } from './types';
